import React, { createContext, useContext, useState } from "react";
import { RoomPublicUserInfoList } from "./room-chat/RoomChatTypes";

export type RoomContextType = {
    // User info for all currently displayed chat message authors
    messageAuthors: RoomPublicUserInfoList;
    setMessageAuthors: (authorList: RoomPublicUserInfoList) => void;
    totalMemberCount: number;
    setTotalMemberCount: (count: number) => void;
    isMembersModalOpen: boolean;
    setIsMembersModalOpen: (isOpen: boolean) => void;
};

export const RoomContext: React.Context<RoomContextType | undefined> = createContext<RoomContextType | undefined>(
    undefined,
);

interface RoomContextProviderProps {
    children?: React.ReactNode;
}

export const RoomContextProvider = ({ children }: RoomContextProviderProps) => {
    const [messageAuthors, setMessageAuthors] = useState<RoomPublicUserInfoList>({});
    const [totalMemberCount, setTotalMemberCount] = useState(0);
    const [isMembersModalOpen, setIsMembersModalOpen] = useState(false);

    return (
        <RoomContext.Provider
            value={{
                messageAuthors,
                setMessageAuthors,
                totalMemberCount,
                setTotalMemberCount,
                isMembersModalOpen,
                setIsMembersModalOpen,
            }}
        >
            {children}
        </RoomContext.Provider>
    );
};

export const useRoomContext = () => {
    const context = useContext(RoomContext);
    if (context == null) {
        throw new Error("Missing RoomContext");
    }
    return context;
};
